module.exports = __webpack_public_path__ + "static/media/2.06a2ea1f.jpg";